import styled from 'styled-components'
import CSS from 'csstype'

import { Breakpoints, Margins } from '../../constants'

interface RowProps {
  alignItems?: CSS.Property.AlignItems
  alignContent?: CSS.Property.AlignContent
  justifyContent?: CSS.Property.JustifyContent
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  ${(p) => `
    ${p.alignItems ? `align-items: ${p.alignItems};` : ''}
    ${p.alignContent ? `align-content: ${p.alignContent};` : ''}
    ${p.justifyContent ? `justify-content: ${p.justifyContent};` : ''}
  `}
`

export const Columns = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    flex-direction: column;
    align-items: center;
  }
`

interface ColumnProps {
  flex?: CSS.Property.Flex
  alignItems?: CSS.Property.AlignItems
  alignContent?: CSS.Property.AlignContent
  justifyContent?: CSS.Property.JustifyContent
}

export const Column = styled.div<ColumnProps>`
  flex: ${(p) => (p.flex ? p.flex : 1)};

  @media (max-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    justify-content: center;
    margin: ${Margins.l}px 0px ${Margins.l}px 0px;
  }
`

interface GridProps {
  columns?: number
}

export const Grid = styled.div<GridProps>`
  display: grid;
  grid-gap: 1rem;

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const MaxWidthContainer = styled.div`
  @media only screen and (max-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    max-width: 600px;
  }
`
